import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default class Utility {}
_class = Utility;
/**
 * @param {Any} - Any datatype
 * @returns true if it is not an Array or if it is an empty array
 */
Utility.isArrayEmpty = arrayList => !Array.isArray(arrayList) || !arrayList.length;
/**
 * @param {Any} - Any datatype
 * @returns true if it is not an Object or if it is an empty Object
 * @Note - It will always return true while passing an object which is created using class constructor
 */
Utility.isObjectNull = obj => !obj || obj.constructor !== Object || !Object.keys(obj).length;
/**
 * @param {Any} - Any datatype
 * @returns true if it is not a String or if it is an empty String
 */
Utility.isEmptyStr = str => !str || str.constructor !== String || !str.trim().length;
/**
 * @param {Any} - Any datatype
 * @returns true if it is not null or undefined variable
 */
Utility.isDefined = obj => obj !== null && obj !== undefined;
Utility.hasNumericalValue = number => typeof number === 'number';
/**
 * @param {Any} - Any datatype
 * @returns true if it is a falsy value based on the datatype
 */
Utility.isEmptyElement = ele => !!(!ele || ele.constructor === Object && !Object.keys(ele).length || Array.isArray(ele) && !ele.length);
/**
 * @param  {Any} of valid number in String or Number type. It can be mixed as well
 * @returns the converted number in Number type or returns 0 if any value other than number is passed
 * @note - Invalid numbers(undefined, null, {}, [], "", "some text", true, false, NaN) will be treated as 0 by default.
 */
Utility.convertNumberWithDecimals = number => Number(number !== true && Number(number) && parseFloat(number).toFixed(2) || 0);
/**
 * @param  {...Any} Array of valid numbers in String or Number type. It can be mixed as well
 * @returns the calculated numbers in Number type or returns 0 if any value other than number is passed
 * @note - Invalid numbers(undefined, null, {}, [], "", "some text", false, NaN) will be treated as 0 by default. Exceptionally true will be treated as 1 by default.
 */
Utility.addNumbers = function () {
  for (var _len = arguments.length, numbers = new Array(_len), _key = 0; _key < _len; _key++) {
    numbers[_key] = arguments[_key];
  }
  return numbers.reduce((accumulator, currentValue) => Number(currentValue || 0) + accumulator, 0) || 0;
};
// this method Can also be used as a parser
Utility.subNumbers = function () {
  for (var _len2 = arguments.length, numbers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    numbers[_key2] = arguments[_key2];
  }
  return numbers.reduce((accumulator, currentValue) => Number(accumulator || 0) - Number(currentValue || 0)) || 0;
};
Utility.mulNumbers = function () {
  for (var _len3 = arguments.length, numbers = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    numbers[_key3] = arguments[_key3];
  }
  return numbers.reduce((accumulator, currentValue) => Number(currentValue || 0) * accumulator, 1) || 0;
};
Utility.divideNumbers = (number1, number2) => Number(number1) !== 0 && Number(number2) !== 0 && Number(number1) / Number(number2) || 0;
/**
 * @param  {...Any} Array of valid numbers in String or Number type. It can be mixed as well
 * @returns the calculated numbers in Number type or returns 0 if any value other than number is passed
 * @note - Invalid numbers(undefined, null, {}, [], "", "some text", true, false, NaN) will be treated as 0 by default. Exceptionally true will be treated as 1 by default.
 */
Utility.addNumbersAsFloat = function () {
  return Number(_class.convertNumberWithDecimals(_class.addNumbers(...arguments)));
};
Utility.subNumbersAsFloat = function () {
  return Number(_class.convertNumberWithDecimals(_class.subNumbers(...arguments)));
};
Utility.mulNumbersAsFloat = function () {
  return Number(_class.convertNumberWithDecimals(_class.mulNumbers(...arguments)));
};
Utility.divideNumbersAsFloat = (number1, number2) => Number(_class.convertNumberWithDecimals(_class.divideNumbers(number1, number2)));
/**
 * @param {Any} valid numbers of string or Number type.
 * @returns the one percentage of value passed as parameter. For the invalid numbers null will be returned.
 * @note - The Invalid numbers are (undefined, null, {}, [], "", "some text", true, false, NaN).
 */
Utility.calcPercentage = number => number !== true && Number(number || 0) / 100 || null;
Utility.mergeArrays = function () {
  let arrayOfArrays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return !_class.isArrayEmpty(arrayOfArrays) && arrayOfArrays.reduce((accumulator, currentArray) => [...accumulator, ...currentArray], []) || [];
};
Utility.areArraysSameByValues = (array1, array2) => Array.isArray(array1) && Array.isArray(array2) && array1.sort().join() === array2.sort().join();
Utility.deepCopy = original => original && JSON.parse(JSON.stringify(original));
/**
 * @param {String} queryString accepts querystring as input (or) it will take query string from the current url
 * @returns return the query as key-value pairs (as Object)
 * @sample
 *        1. "?sample=data" / "sample=data"   : returns {sample: "data"}
 *        2. ""  / "  "                       : returns current URL's query param as key-value pairs
 *        3. "sample" / "sample="             : return { sample: "" }
 *        4. Other dataTypes                  : returns empty Object ({})
 */
Utility.getQueryParamsAsObject = function () {
  let queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
  return !_class.isEmptyStr(queryString) && Object.fromEntries(new URLSearchParams(queryString.trim()).entries()) || {};
};
Utility.getValueFromQueryParam = function () {
  let queryParamKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _class.getQueryParamsAsObject()[queryParamKey] || '';
};
Utility.constructQueryStringFromObj = function () {
  let queryParamObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return !_class.isObjectNull(queryParamObj) && Object.keys(queryParamObj).reduce((acc, currKey) => "".concat(acc).concat(acc === '?' ? '' : '&').concat(currKey, "=").concat(queryParamObj[currKey]), '?') || '';
};
/**
 * @param {Array of Objects} - accepts array of Objects
 * @param {String} - accepts the key to be processed to create an Object
 * @returns Object ( Key - Value ) pair.
 * @sample
 *  1. ([{ state: 'TN', capital: 'Chennai' }, { state: 'KA', capital: 'Bangalore' }], 'state')    : return { TN: { state: 'TN', capital: 'Chennai' }, KA: { state: 'KA', capital: 'Bangalore' } }
 *  2. (undefined, 'capital) : returns {}
 *  3. ([{}, {}, 'test'], '') : returns {}
 */
Utility.getArrayOfObjAsObj = (array, key) => !_class.isEmptyStr(key) && !_class.isArrayEmpty(array) && array.reduce((acc, obj) => !_class.isObjectNull(obj) ? _objectSpread(_objectSpread({}, acc), {}, {
  [obj[key]]: obj
}) : acc, {}) || {};
Utility.isValidEmail = function () {
  let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return !_class.isEmptyStr(string) && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(string);
};
Utility.openLink = (link, openInNewTab) => link && window.open(link, openInNewTab && '_blank');
Utility.arrayToggleInsert = function () {
  let array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let value = arguments.length > 1 ? arguments[1] : undefined;
  return (Array.isArray(array) && array.includes(value) ? array.filter(currVal => currVal !== value) : [...array, value]) || array;
};
Utility.differentBtnDates = (firstDate, secondDate, numberOf) => {
  switch (numberOf) {
    case 'seconds':
      return Math.floor((secondDate - firstDate) / 1000);
    case 'minutes':
      let seconds = _class.differentBtnDates(firstDate, secondDate, 'seconds');
      return Math.floor(seconds / 60);
    case 'hours':
      let minutes = _class.differentBtnDates(firstDate, secondDate, 'minutes');
      return Math.floor(minutes / 60);
    case 'days':
      let hours = _class.differentBtnDates(firstDate, secondDate, 'hours');
      return Math.floor(hours / 24);
    case 'weeks':
      let days = _class.differentBtnDates(firstDate, secondDate, 'days');
      return Math.floor(days / 7);
    case 'years':
      let date1 = new Date(firstDate);
      let date2 = new Date(secondDate);
      return date2.getFullYear() - date1.getFullYear();
    case 'months':
      let d1 = new Date(firstDate);
      let d2 = new Date(secondDate);
      let years = _class.differentBtnDates(firstDate, secondDate, 'years');
      return years * 12 + (d2.getMonth() - d1.getMonth());
    default:
      return secondDate - firstDate;
  }
  ;
};